import AppDispatcher from "../Dispatcher";
import { AppActionConstants } from "./AppActionConstants";
import AppConfig from "../../AppConfig";
import AppSDK from "@growthos/ui-app-sdk";
import { fetchWithAuthGet, fetchWithAuthPost, fetchWithAuthPut } from "../FetchWithAuth";
import BookFiltersStore from "../Stores/BookFiltersStore";
import ErrorHelpers from "../../Components/FormBuilder/ErrorHelpers";

const basePath = AppConfig.getBookApiBasePath();

export const fetchAuditLevelConfig = (platformID, AgencyID, ClientID, CountryID, RegionID) => {
	const contextValues = BookFiltersStore.getContextValues();
	// `${Book2.ApiBasePath}/custom/GetAuditLevelsByPlatformID/1`

	return fetchWithAuthGet(
		`${basePath.ApiBasePath}/plook/MasterPlatformView/GetAuditLevelsByPlatformID/${contextValues.contextId}/${contextValues?.agency?.name}/${contextValues?.client?.name}/${contextValues?.region?.name}/${contextValues?.country?.name}/${platformID}`
	)
		.then((response) => {
			AppDispatcher.dispatch({
				type: AppActionConstants.fetchAuditLevelConfig, // "FETCHAUDITLEVELCONFIG"
				value: response
			});
		})
		.catch(() => {
			console.log("error");
		});
};

export const fetchWorkbookActivationCampaigns = (campaignID) => {
	return fetchWithAuthGet(`${basePath.ApiBasePath}/plook/Campaign/GetAllCampaignsMetaData/${campaignID}`)
		.then((response) => {
			AppDispatcher.dispatch({
				type: AppActionConstants.fetchWorkbookActivationCampaigns, // "FETCHWORKBOOKACTIVATIONCAMPAIGNS"
				value: response
			});
		})
		.catch((error) => {
			console.log("error", error);
		});
};

export const fetchPlacementAPIConfig = (config) => {
	const contextValues = BookFiltersStore.getContextValues();
	return fetchWithAuthGet(
		`${basePath.ApiBasePath}/plook/Placement/GetPlatformAccountAPIConfiguration/${contextValues.contextId}/${contextValues?.agency?.name}/${contextValues?.client?.name}/${contextValues?.region?.name}/${contextValues?.country?.name}/${config.platformID}`
	)
		.then((response) => {
			AppDispatcher.dispatch({
				type: AppActionConstants.placementAPIConfigFetched,
				value: response
			});
		})
		.catch(() => {
			console.log("error");
		});
};

export const deletePlatform = (hierarchyLevel, id, deleteType) => {
	return fetchWithAuthPut(`${basePath.ApiBasePath}/plook/${hierarchyLevel}/DeleteItem/${id}`)
		.then((response) => {
			AppDispatcher.dispatch({
				type: AppActionConstants[deleteType],
				value: id
			});
		})
		.catch(() => {
			console.log("error");
		});
};

export const bulkDeletePlatform = (hierarchyLevel, ids, deleteType, onFailure = () => {}) => {
	return fetchWithAuthPut(`${basePath.ApiBasePath}/plook/${hierarchyLevel}/DeleteItem`, JSON.stringify({ ID: ids }))
		.then((response) => {
			AppDispatcher.dispatch({
				type: AppActionConstants[deleteType],
				value: ids
			});
		})
		.catch((error) => {
			ErrorHelpers.displayErrorToasts(error, "workbookToasts", `${hierarchyLevel.replace(/(?=[A-Z])/g, " ")}(s) could not be deleted.`);
			onFailure();
		});
};

export const fetchEnabledColumns = (campaignID) => {
	return fetchWithAuthGet(`${basePath.ApiBasePath}/plook/Campaign/GetUserCampaignHierarchyColumnheader/${campaignID}`)
		.then((response) => {
			AppDispatcher.dispatch({
				type: AppActionConstants.getEnabledColumns,
				value: response
			});
		})
		.catch((error) => {
			console.log("error", error);
		});
};

export const insertUpdateEnabledColumns = (payload) => {
	return fetchWithAuthPost(`${basePath.ApiBasePath}/plook/Campaign/InsertUpdateUserCampaignHierarchyColumnheader`, JSON.stringify(payload))
		.then((response) => {
			AppDispatcher.dispatch({
				type: AppActionConstants.setEnabledColumns,
				value: response
			});
		})
		.catch((error) => {
			console.log("error", error);
		});
};

export const toggleWorkbookBudgetLocked = (campaignId, locked) => {
	// QPs: /campaignid/islocked/isfromWorkbook
	return fetchWithAuthPost(`${basePath.ApiBasePath}/plook/Campaign/LockUnlockCampaignPlacements/${campaignId}/${locked}/true`).then((response) => {
		AppDispatcher.dispatch({
			type: AppActionConstants.lockUnlockWorkbookBudgetSuccess,
			value: { campaignId, locked }
		});
	});
};

export const toggleTrafficManager = (isEnabled, campaignID) => {
	const aarc = AppSDK.getContext();
	const contextValues = BookFiltersStore.getContextValues();
	return fetchWithAuthPost(
		`${basePath.ApiBasePath}/plook/Campaign/SetTrafficManager`,
		JSON.stringify({
			// MasterAgencyDivisionID: aarc.masterAgencyDivisionID,
			// MasterBusinessUnitID: aarc.masterBusinessUnitID,
			MasterAgencyDivisionName: contextValues?.agency?.name,
			MasterBusinessUnitName: contextValues?.client?.name,
			CampaignID: [campaignID],
			IsTrafficManagerEnabled: isEnabled ? 1 : 0
		})
	).then(() => {
		AppDispatcher.dispatch({
			type: AppActionConstants.trafficManagerToggled,
			value: isEnabled
		});
	});
};
